import { READINESS_MAX_ACCURACY_M } from './constants';

/**
 * v22 BOLT-115 — the readiness copy, in ONE place.
 *
 * The field bug had two halves: the gate got stuck (fixed in the clients), and
 * when it was stuck it said nothing actionable. "Waiting on precise GPS" is a
 * dead end; the player can't tell whether to wait, walk outside, or open
 * Settings. Naming the number turns it into a nudge.
 *
 * Server (`locationGate`), web lobby, and iOS lobby all render from here /
 * its Swift mirror in `Format.swift`, so the three surfaces can never drift.
 */
export function preciseReason(accuracyM?: number): string {
  if (accuracyM == null) return 'needs precise location';
  return `fix is ${Math.round(accuracyM)} m, needs ${READINESS_MAX_ACCURACY_M} m or better`;
}

/** The lobby's per-player waiting line: who we're waiting on, and why. */
export function readinessReason(slot: {
  connected?: boolean;
  locationPrecise?: boolean;
  hasFix?: boolean;
  accuracyM?: number;
}): string | null {
  if (slot.connected === false) return 'reconnecting';
  if (!slot.hasFix) return 'waiting for GPS';
  if (!slot.locationPrecise) return preciseReason(slot.accuracyM);
  return null;
}
